import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CustomColumnComponent } from '@vendure/admin-ui/core';

@Component({
  standalone: false,
    selector: 'customer-profile-column',
    template: ` <span class="{{ statusClass }}">{{ statusText }}</span> `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            .approved {
                color: #118c4f;
                font-weight: bold;
            }
        `,
        `
            .under_analysis {
                color: #e69e00;
                font-weight: bold;
            }
        `,
        `
            .disapproved {
                color: #d00036;
                font-weight: bold;
            }
        `,
    ],
})
export class CustomerProfileColumnComponent implements CustomColumnComponent {
    @Input() rowItem: any;

    get status(): string {
        return this.rowItem?.customFields?.profileAnalysis || '';
    }

    get statusText(): string {
        switch (this.status) {
            case 'approved':
                return 'Aprovado';
            case 'under_analysis':
                return 'Em análise';
            case 'disapproved':
                return 'Reprovado';
            default:
                return '-';
        }
    }

    get statusClass(): string {
        return this.status;
    }
}
